import {
    getPastCourse,
    getActiveCourse,
    getNextCourse,
    getPendingCourse,
} from "../Redux/Actions/PunctualCourseActions";
import { DeclarationStatusEnumColor, UrssafServiceStatEnumColor } from "../Enum/UrssafStatusEnum";
import { GET_PAST_COURSE, GET_ACTIVE_COURSE, GET_NEXT_COURSE, GET_PENDING_COURSE } from "../Redux/Actions/PunctualCourseActions";

export const REDUX_TYPE_MAP = {
    historique: GET_PAST_COURSE,
    actif: GET_ACTIVE_COURSE,
    avenir: GET_PENDING_COURSE,
    brouillon: GET_NEXT_COURSE,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type CourseType = "historique" | "actif" | "avenir" | "brouillon";

export interface ListCourseProps {
    type?: CourseType;
    limit?: number;
    hidePagination?: boolean;
}

export interface CourseTypeConfig {
    action: (data: any) => any;
    // dataKey?: any
    stateKey: string;
    pageKey: string;
    limitKey: string;
    /** Afficher le filtre par période (serveur) */
    showDateFilter: boolean;
    /** Afficher le bouton "Montant total facturé" */
    showMontant: boolean;
    /** Afficher le filtre + statut URSSAF (sinon : statut basé sur la date) */
    showUrssafFilter: boolean;
    /** Cours brouillon (isCoursePass=true dans la logique métier) */
    isCoursePass: boolean;
    emptyEmoji: string;
    emptyLabel: string;
}

export const COURSE_TYPE_CONFIG: Record<CourseType, CourseTypeConfig> = {
    historique: {
        action: getPastCourse,
        stateKey: "pastCourse",
        pageKey: "currentPagePast",
        limitKey: "limitPast",
        showDateFilter: true,
        showMontant: true,
        showUrssafFilter: true,
        isCoursePass: false,
        emptyEmoji: "📚",
        emptyLabel: "Aucun historique de cours disponible",
    },
    actif: {
        action: getActiveCourse,
        stateKey: "activeCourse",
        pageKey: "currentPage",
        limitKey: "limit",
        showDateFilter: false,
        showMontant: false,
        showUrssafFilter: true,
        isCoursePass: false,
        emptyEmoji: "🔥",
        emptyLabel: "Aucun cours ce mois-ci",
    },
    avenir: {
        action: getPendingCourse,
        stateKey: "pendingCourse",
        pageKey: "currentPagePending",
        limitKey: "limitPending",
        showDateFilter: false,
        showMontant: false,
        showUrssafFilter: false,
        isCoursePass: false,
        emptyEmoji: "📅",
        emptyLabel: "Aucun cours à venir",
    },
    brouillon: {
        action: getNextCourse,
        stateKey: "nextCourse",
        pageKey: "currentPageNext",
        limitKey: "limitNext",
        showDateFilter: false,
        showMontant: false,
        showUrssafFilter: false,
        isCoursePass: true,
        emptyEmoji: "📝",
        emptyLabel: "Aucun brouillon en attente",
    },
};

export const STATUS_OPTIONS = [
    { value: "", label: "Tous les statuts" },
    ...Object.entries(UrssafServiceStatEnumColor).map(([, meta]: [string, any]) => ({
        value: meta.value ?? "",
        label: meta.title ?? "",
    })),
];

/**
 * Filtre « Statut » de l'onglet Passés (Mes cours repensé) : statuts URSSAF,
 * cours terminés pas encore transmis (valeur EN_COURS, comprise par l'API des
 * cours passés, alors que STATUS_OPTIONS envoie « null ») et statuts de
 * déplacement (valeur du declarationStatus). « Cours à venir » n'a pas de sens
 * sur des cours passés. Les anciennes listes gardent STATUS_OPTIONS.
 */
export const PAST_STATUS_OPTIONS = [
    { value: "", label: "Tous les statuts" },
    ...Object.entries(UrssafServiceStatEnumColor)
        .filter(([key]) => key !== "COURS_PREVU" && key !== "EN_COURS")
        .map(([, meta]: [string, any]) => ({ value: meta.value ?? "", label: meta.title ?? "" })),
    { value: "EN_COURS", label: UrssafServiceStatEnumColor.EN_COURS.title },
    ...[DeclarationStatusEnumColor.PENDING_VERIFICATION, DeclarationStatusEnumColor.PENDING_APPROVAL, DeclarationStatusEnumColor.REJECTED]
        .map((meta) => ({ value: meta.value as string, label: meta.title })),
];
